import { Dialog, DialogContent } from '@/components/ui/dialog';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ImageViewerDialog({ open, onOpenChange, images, currentIndex, onIndexChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl">
        <div className="relative">
          {images.length > 0 && (
            <>
              <img 
                src={`${API_URL}/api/image/${images[currentIndex].split('/').pop()}`}
                alt="View" 
                className="w-full h-auto max-h-[70vh] object-contain"
                onError={(e) => {
                  console.error('Image failed to load:', images[currentIndex]);
                  e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200"><text x="50%" y="50%" text-anchor="middle">Image not found</text></svg>';
                }}
              />
              
              {/* Navigation Arrows */}
              {images.length > 1 && (
                <>
                  <button
                    onClick={() => onIndexChange((currentIndex - 1 + images.length) % images.length)}
                    className="absolute left-2 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 text-white p-3 rounded-full hover:bg-opacity-70"
                  >
                    ←
                  </button>
                  <button
                    onClick={() => onIndexChange((currentIndex + 1) % images.length)}
                    className="absolute right-2 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 text-white p-3 rounded-full hover:bg-opacity-70"
                  >
                    →
                  </button>
                </>
              )}
              
              {/* Image Counter */}
              <div className="absolute bottom-2 left-1/2 -translate-x-1/2 bg-black bg-opacity-50 text-white px-3 py-1 rounded">
                {currentIndex + 1} / {images.length}
              </div>
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
